import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "../locales/duck";
import controllerReservas from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Select2, Text } = Inputs;

function CrearReservaRestaurante({ history, match }) {
  const dispatch = useDispatch();

  const modelLocal = useSelector((state) => state.localById);
  const modelPrimerDia = useSelector((state) => state.primerDiaDisponible);
  const modelHorarios = useSelector((state) => state.getAmbientes);
  const modelReserva = useSelector((state) => state.generarReservas);

  const [local, setLocal] = useState(null);
  const [nombre, setNombre] = useState("");
  const [ci, setCi] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [servicioPadre, setServicioPadre] = useState(null);
  const [servicioPadreNombre, setServicioPadreNombre] = useState(null);
  const [servicioNombre, setServicioNombre] = useState(null);
  const [horarioSelected, setHorarioSelected] = useState(null);
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState(null);
  const [horarioId, setHorarioId] = useState(null);
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [serviciosOptions, setServiciosOptions] = useState([]);
  const [servicio, setServicio] = useState(null);
  const [minMonth, setMinMonth] = useState(null);
  const [minYear, setMinYear] = useState(null);
  const [minDay, setMinDay] = useState(null);
  const [maxMonth, setMaxMonth] = useState(null);
  const [maxYear, setMaxYear] = useState(null);
  const [maxDay, setMaxDay] = useState(null);
  const [dias, setDias] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [nroMesa, setNroMesa] = useState(null);
  const [validoPara, setValidoPara] = useState(2);
  const [maxPersonas, setMaxPersonas] = useState(0);

  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesional, setProfesional] = useState(null);
  const [excludedDates, setExcludedDates] = useState([]);
  const [horarioOptions, setHorarioOptions] = useState([]);
  const [horario, setHorario] = useState(null);

  const [localId, setLocalId] = useState(
    match.params.organizacion ? match.params.organizacion : null
  );

  useEffect(() => {
    dispatch(controller.localByIdThunk(localId));

    const horarioSelectedAux = localStorage.getItem("horarioSelected");
    const subcategoriaAux = localStorage.getItem("subcategoria");
    const servicioAux = localStorage.getItem("servicio");

    setHorarioSelected(JSON.parse(horarioSelectedAux));
    setServicioPadreNombre(JSON.parse(subcategoriaAux));
    setServicioNombre(JSON.parse(servicioAux));
  }, []);

  useEffect(() => {
    const data = modelReserva?.data?.data;
    const error = modelReserva?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerReservas.generarReservasDuck.actions.clear());
    }
    if (data && data.data) {
      localStorage.removeItem("horarioSelected");
      localStorage.removeItem("subcategoria");
      localStorage.removeItem("servicio");
      history.push(`/calendarioLocal/${match.params.organizacion}`);

      dispatch(controllerReservas.generarReservasDuck.actions.clear());
    }
  }, [modelReserva]);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      setLocal(data.data);
      const subcategoriaOptions = data.data.subCategorias.map((row) => ({
        label: row.nombre,
        value: row.id,
      }));
      setServiciosPadreOptions(subcategoriaOptions);
      dispatch(controller.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    const data = modelPrimerDia?.data?.data;
    const error = modelPrimerDia?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerReservas.primerDiaDisponibleDuck.actions.clear());
    }
    if (data) {
      const daysInLastMonth = moment(
        data.data.dia[0].lastYear + "-" + data.data.dia[0].lastMonth,
        "YYYY-MM"
      ).daysInMonth();
      if (!minMonth && !minYear && !minDay) {
        setMinDay(data.data.dia[0].dia);
        setMinMonth(data.data.dia[0].mes);
        setMinYear(data.data.dia[0].anho);

        setMaxDay(daysInLastMonth);
        setMaxMonth(data.data.dia[0].lastMonth);
        setMaxYear(data.data.dia[0].lastYear);
      }
      setMonth(data.data.dia[0].mes);
      setYear(data.data.dia[0].anho);

      dispatch(
        controllerReservas.getAmbientesEntreFechasThunk(
          data.data.dia[0].anho +
            "-" +
            data.data.dia[0].mes +
            "-" +
            data.data.dia[0].dia,
          data.data.dia[0].lastYear +
            "-" +
            data.data.dia[0].lastMonth +
            "-" +
            daysInLastMonth,
          servicio
        )
      );

      dispatch(controllerReservas.primerDiaDisponibleDuck.actions.clear());
    }
  }, [modelPrimerDia]);

  useEffect(() => {
    const data = modelHorarios?.data?.data;
    const error = modelHorarios?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerReservas.horariosEntreFechasDuck.actions.clear());
    }
    if (data) {
      setDias(data.data);
      const diasDisponibles = Object.keys(data.data);

      const daysInLastMonth = moment(
        year + "-" + month,
        "YYYY-MM"
      ).daysInMonth();
      const arrayFinal = [];
      for (let i = 1; i <= daysInLastMonth; i++) {
        const formattedMonth =
          Number(month) > 9 ? Number(month) : "0" + Number(month);
        const formattedDay = Number(i) > 9 ? Number(i) : "0" + Number(i);
        const formatted = year + "-" + formattedMonth + "-" + formattedDay;

        if (!diasDisponibles.includes(formatted)) {
          const fechaAProcesar = new Date(year, month - 1, i);
          arrayFinal.push(fechaAProcesar);
        }
      }

      setExcludedDates(arrayFinal);

      dispatch(controllerReservas.horariosEntreFechasDuck.actions.clear());
    }
  }, [modelHorarios]);

  const getDateUtc = (fecha) => {
    const day = fecha
      ? moment(fecha).utc().format("YYYY-MM-DD")
      : moment().utc().format("YYYY-MM-DD");
    return day;
  };

  function submit() {
    if (
      !nombre ||
      !validoPara ||
      !servicioNombre ||
      !horarioSelected ||
      !servicioPadreNombre
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (validoPara > horarioSelected.maxPersonas) {
      alert(
        "El numero de personas de la reserva es mayor los lugares disponibles"
      );
      return;
    }

    const servicioSelected = local.servicios.filter(
      (elem) => elem.id === servicioNombre.value
    );

    const fechaSplitted = moment(horarioSelected.fecha)
      .format("YYYY-MM-DD")
      .split("-");

    const fechaFinal =
      moment(horarioSelected.fecha).format("YYYY-MM-DD") + " 00:01";

    let data = {
      origen: "ADMIN",
      usuarioId: null,
      ci: ci,
      nombre: nombre,
      categoriaId: local.categoriaId,
      direccion: direccion,
      telefono: telefono,
      ciudad: ciudad,
      localId: match.params.organizacion,
      profesionalId: null, //restaurante null
      servicioId: servicioNombre.value,
      subCategoriaId: servicioPadreNombre.value,
      duracion: 0,
      maxPersonas: horarioSelected.maxPersonas,
      anho: fechaSplitted[0],
      mes: Number(fechaSplitted[1]),
      dia: Number(fechaSplitted[2]),
      fecha: fechaFinal,
      hora: null,
      horarioId: horarioSelected._id,
      ambiente: horarioSelected.ambienteId, // peluqueria null
      ambienteNombre: horarioSelected.nombre,
      validaPara: validoPara, //peluqueria null
      metodoPago: 10,
      servicioNombre: servicioSelected[0].nombre,
      categoriaNombre: local.categoriaNombre,
      profesionalNombre: null,
      localNombre: local.nombre,
      tiempoCancelar: local.tiempoCancelar,
      nroMesa,
    };

    dispatch(controllerReservas.generarReservasThunk({ reservas: [data] }));
  }

  return (
    <Content title="Crear reserva" browserTitle="Crear reserva" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Crear reserva"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(
                      `/calendarioLocal/${match.params.organizacion}`
                    );
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelReserva.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelReserva.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Ciudad"
              value={ciudad}
              onChange={(evt) => setCiudad(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Direccion"
              value={direccion}
              onChange={(evt) => setDireccion(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label="Documento"
              value={ci}
              onChange={(evt) => setCi(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label="Telefono (981XXXXXX)"
              value={telefono}
              onChange={(evt) => setTelefono(evt.target.value)}
            />



            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label="Numero de mesa"
              value={nroMesa}
              onChange={(evt) => setNroMesa(evt.target.value)}
            />

            {horarioSelected ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  <Etiqueta
                    texto={`Válido para (Máximo: ${horarioSelected.maxPersonas})`}
                    obligatorio={true}
                  />
                }
                value={validoPara}
                inputType="number"
                onChange={(evt) => setValidoPara(evt.target.value)}
              />
            ) : null}

            {servicioPadreNombre && servicioNombre && horarioSelected ? (
              <>
                <text>
                  <strong>{`Subcategoria: ${servicioPadreNombre.label}`}</strong>
                </text>
                <br />
                <text>
                  <strong>{`Servicio: ${servicioNombre.label}`}</strong>
                </text>
                <br />
                <text>
                  <strong>{`Ambiente: ${horarioSelected.nombre}`}</strong>
                </text>
                <br />
                <text>
                  <strong>{`Fecha: ${getDateUtc(
                    horarioSelected.fecha
                  )}`}</strong>
                </text>
                <br />
              </>
            ) : null}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default CrearReservaRestaurante;
